const formatTimestamp = (timestamp) => {
  const now = new Date();
  const then = new Date(timestamp);
  const diffInMs = now - then;
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInHours < 24) {
    return `${diffInHours} hr ago`;
  } else {
    const cycleDay = (diffInDays % 13) || 13; // 1 to 13 looping
    return `day ${cycleDay} ago`;
  }
};

const timeAgo = ({ timestamp }) => {
  return <span>{formatTimestamp(timestamp)}</span>;
};

export  {
  timeAgo
}